<template>
  <input type="text"
         :style="{width}"
         :maxlength="props.maxlength"
         @keyup="$cmmn.number.only_keydown"
         @keydown="$cmmn.number.only_keyup"
         @change="numberip_input"
         v-model="num">
</template>

<script setup>
import {ref, defineProps, defineEmits, toRefs, watch} from "vue";

import {getUtils} from "@/utils/import";
const {$cmmn} = getUtils();

const props = defineProps({
  data: {
    type: String,
    required: true
  },
  width: {
    type: String,
    default: '150px',
  },
  maxlength: Number,
  /* for문 사용하는 경우 해당 index 필요해서 추가 */
  index: Number
})

const emits = defineEmits(['input'])

const num = ref(props.data);
const { data } = toRefs(props);
watch(data, (newNum) => {
  num.value = newNum;
});

const numberip_input = () => {
  emits('input', num.value);
}
</script>

<style scoped>

</style>